module.exports = __webpack_public_path__ + "img/DE00524.75638622.png";